import React from 'react';
import { Link } from 'react-router-dom';

function ChamadoSprintCard({ sprintId, sprintNome }) {
    return (
        <div className="chamado-sidebar-card chamado-sprint-card">
            <h4 className="chamado-sidebar-card-titulo">Sprint</h4>
            {sprintId ? (
                <Link to={`/sprint?sprint=${sprintId}`} className="chamado-sprint-link">
                    {sprintNome && sprintNome.trim() ? sprintNome : `Sprint #${sprintId}`}
                </Link>
            ) : (
                <span className="chamado-sprint-vazio">Não está em sprint</span>
            )}
        </div>
    );
}

export default ChamadoSprintCard;
